<html>
<head>
	<meta charset="UTF-8">
	<script src="https://unpkg.com/geotiff@0.4.1/dist/main.js"></script>
    <script src="https://unpkg.com/plotty@0.2.0/src/plotty.js"></script>
    <script src="leaflet-geotiff.js"></script>

	<script src="https://code.jquery.com/jquery-1.12.4.js"></script>
	<script src="https://code.jquery.com/ui/1.12.1/jquery-ui.js"></script>
    <!-- Load any renderer you need -->
    <script src="leaflet-geotiff-plotty.js"></script>
	<script src="https://raw.githubusercontent.com/calvinmetcalf/leaflet.shapefile/gh-pages/leaflet.shpfile.js"></script>
	<script src="https://raw.githubusercontent.com/calvinmetcalf/leaflet.shapefile/gh-pages/shp.js"></script>
</head>
<body>
	<div id="map">
		
	</div>

	<div id="hideable">
		<button id="show-button">
			<img src="../assets/land.svg" class = "layerPic">
		</button>
		<button id="hide-button">
			<img src="../assets/land.svg" class = "layerPic">
		</button>
		<div id="sortables">
			<table id="items">
			</table>
			<input type="checkbox" name="trees" id = "koki">
			<label for="vehicle3"> Iezīmēt kokus</label><br><br>
		</div>
	</div>
</body>
</html>